import { SelectionListServant } from '../../global/servants/selection_list_servant';
import { QueryMediator } from 'utility-ng-kernel';
import { Major } from './../builders/major_builder';
import { ICommand, IDefineCommand, IDatasource, IQueryMediator, IQuery } from 'core-ts-types';
import { ITransferMajorsDatasource } from '../datasources/transfer_majors_datasource';
import moveFocusToNextFocusableElementOnDeletion from '../../global/utilities/move_focus_to_next_focusable_element_on_deletion';

angular.module('capability-ng-transfer').factory(
  'deselectTransferMajorCommand',
  (
    defineCommand: IDefineCommand,
    QueryMediator: IQueryMediator,
    ngSelectionListServant: SelectionListServant,
    ngTransferMajorsDatasource: ITransferMajorsDatasource,
    $http: ng.IHttpService
  ): ICommand => {
    return defineCommand('deselectTransferMajorCommand', function deselectMajor(
      deferred: ng.IDeferred<IQuery[]>,
      major: Major
    ): void {
      $http({
        method: 'DELETE',
        url: `student/program/${major.id}/`
      })
        .then((): void => {
          // TODO add timestamp servant?

          moveFocusToNextFocusableElementOnDeletion();
          major.created_ts = undefined;
          ngSelectionListServant.unselect(
            ngTransferMajorsDatasource.model.majorsSelection,
            _.find(ngTransferMajorsDatasource.model.majorsSelection.list, (item: any) => item.id === major.id)
          );
          _.set(major, 'isSelected', false);
          ngTransferMajorsDatasource.put(major);
          deferred.resolve(QueryMediator.runQueries(ngTransferMajorsDatasource));
        })
        .catch(deferred.reject);
    });
  }
);



// WEBPACK FOOTER //
// ./app/lib/transfer/commands/deselect_transfer_major_query_command.ts